// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__KJjeG","searchbar":"SearchBar_searchbar__BlE3q","search--btn":"SearchBar_search--btn__j7M2s"};